module.exports = __webpack_public_path__ + "img/benchnine-v9-latin-regular.de74a158.svg";